import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

export class MarketingAnalyticsPageViewEventType extends MarketingAnalyticsEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_PAGE_LOAD;
    }

    getBody(event: any): MarketingAnalyticsEvent {
        const baseEvent = this.baseEvent(event);
        return {
            ...baseEvent,
            event_type: this.getEventType(event),
        };
    }
}
